import { getScrollableParent, getStickyHeaderOffset, RECORD_STICKY_BOOKMARKS_ATTR } from './scroll/scrollExpandedSectionIntoView';

interface ScrollOptions {
  behavior: ScrollBehavior;
  offset: number;
  elementSelector: string;
}

const DEFAULT_FIELD_ID_SELECTOR = '[data-field-id="{id}"]';

export const scrollToError = (errorFieldIds: string[], options: Partial<ScrollOptions> = {}): void => {
  const scrollOptions: ScrollOptions = {
    behavior: 'smooth',
    offset: 100,
    elementSelector: DEFAULT_FIELD_ID_SELECTOR,
    ...options,
  };

  const errorElements = getElementsByErrorIds(errorFieldIds, scrollOptions);
  if (errorElements.length === 0) return;

  const sortedElements = sortElementsByTop(errorElements);

  scrollToElement(sortedElements[0], scrollOptions);
};

export const getElementsByErrorIds = (errorFieldIds: string[], scrollOptions: ScrollOptions) => {
  return errorFieldIds
    .map((fieldId) => {
      const selector = scrollOptions.elementSelector.replace('{id}', fieldId);
      return document.querySelector(selector);
    })
    .filter((element): element is HTMLElement => element !== null && element instanceof HTMLElement);
};

export const sortElementsByTop = (elements: HTMLElement[]) => elements.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

const hasStickyChrome = () =>
  document.querySelector('[data-testid="detail-sticky-header"]') instanceof HTMLElement ||
  document.querySelector(`[${RECORD_STICKY_BOOKMARKS_ATTR}="true"]`) instanceof HTMLElement;

const getErrorScrollOffset = (fallbackOffset: number) => (hasStickyChrome() ? getStickyHeaderOffset(fallbackOffset) : fallbackOffset);

export const scrollToElement = (element: HTMLElement, scrollOptions: ScrollOptions) => {
  const scrollParent = getScrollableParent(element);
  const offset = getErrorScrollOffset(scrollOptions.offset);
  const elementRect = element.getBoundingClientRect();

  if (!scrollParent) {
    const targetTop = window.scrollY + elementRect.top - offset;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: scrollOptions.behavior,
    });

    return;
  }

  const containerRect = scrollParent.getBoundingClientRect();
  const targetTop = scrollParent.scrollTop + elementRect.top - containerRect.top - offset;

  scrollParent.scrollTo({
    top: Math.max(targetTop, 0),
    behavior: scrollOptions.behavior,
  });
};
